<template>
  <md-list class="md-dense">
    <transition-group tag="li">
      <md-list-item class="supplier" v-for="supplier in suppliers" :key="supplier.compnayCode + supplier.supplierCode">
        <md-checkbox
          v-if="selectable"
          :model="selected"
          @change="$emit('update:selected', $event)"
          :value="supplier"
        />
        <span class="md-list-supplier-text compnay-name">{{ supplier.companyName }}</span>
        <span class="md-list-supplier-text supplier-code">{{ supplier.supplierCode }}</span>
        <span class="md-list-supplier-text supplier-name">{{ supplier.supplierName }}</span>
        <span v-if="deletable" class="icon-delete" @click="remove(supplier)">
          <md-icon>remove_circle_outline</md-icon>
        </span>
      </md-list-item>
    </transition-group>
  </md-list>
</template>

<script>
/**
 * 取引先の一覧表示
 */
export default {
  props: {
    /**
     * 表示する取引先リスト
     *
     * 取引先は以下の形式
     *
     * ```javascript
     * {
     *   companyCode: String,
     *   companyName: String,
     *   supplierCode: String,
     *   supplierName: String,
     * }
     * ```
     */
    suppliers: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択されている取引先
     */
    selected: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択可能か
     */
    selectable: {
      type: Boolean,
      default: false,
    },
    /**
     * 削除可能か
     */
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * 要素の削除
     */
    remove(supplier) {
      this.$emit(
        'update:suppliers',
        this.suppliers.filter(i => i.supplierCode !== supplier.supplierCode),
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.supplier {
  width: 100%;

  &:hover {
    background: rgba(0, 0, 0, 0.12);
  }
}

.md-list-supplier-text {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 取引先コード横幅を固定にし、企業名、取引先名称を横幅いっぱいにする
.compnay-name {
  flex: 0.5;
}
.supplier-code {
  flex: 0 0 70px;
}
.supplier-name {
  flex: 1;
}

.icon-delete {
  cursor: pointer;
}

// 取引先一覧の追加/削除時のアニメーション
.supplier {
  transition: all 0.2s ease-in-out;
}
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(50px);
}
.v-leave-active {
  position: absolute;
}
</style>
